export default [
    // *===================Trial Balance List============================---*
    {
        path: '/trialbalance',
            name: 'trialbalance',
            component: () => import('@/views/accounting/trialbalance/TrialBalance.vue'),
            meta: {
                pageTitle: 'Trial Balance',
                breadcrumb: [
                    {
                        text: 'Trial Balance',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]